import { BEIGE_600, GRAY_700, GRAY_900 } from 'constants/styling/theme'
import { Box, Stack, Typography } from '@mui/material'

import { AnalyticsEvent } from 'utils/analytics'
import { EditionType } from '../photoStudioTypes'
import { FC } from 'react'
import LockOutlinedIcon from '@mui/icons-material/LockOutlined'
import { MUIBadge } from 'components/common/MUIBadge'
import { MUIButton } from 'components/common/MUIButton'
import { externalNavigate } from 'utils/helpers'
import { getPricingUrl } from 'utils/localization'
import i18n from 'translations/i18n'
import { useClientPhotoStudio } from '../ClientPhotoStudio.context'
import { useTranslation } from 'react-i18next'

/**
 * Upsell component for non-subscribers in Photo Studio Magic Eraser Panel
 * Displays a promotional section encouraging users to subscribe to access Magic Eraser feature
 * Based on Figma design: https://www.figma.com/design/4KaeWeL3snx2flCNKcT65T/Visual-editing?node-id=4539-6454&m=dev
 * 
 * @example <NonSubscriberMagicEraserUpsell />
 */
export const NonSubscriberMagicEraserUpsell: FC = () => {
  const { t } = useTranslation(['photo_studio_editing', 'common'])
  const { logPhotoStudioEvent } = useClientPhotoStudio()

  const handleSubscribeClick = () => {
    logPhotoStudioEvent(AnalyticsEvent.PHOTO_STUDIO_SAAS_UPSELL, { editionType: EditionType.MAGIC_ERASER })
    externalNavigate(getPricingUrl(i18n.language))
  }

  return (
    <Box
      sx={{ backgroundColor: BEIGE_600, borderRadius: '.8rem', height: 'fit-content', margin: '1.6rem' }}
    >
      <Stack sx={{ padding: 1.6 }}>

        <MUIBadge
          size="xs"
          color="coral"
          icon={<LockOutlinedIcon fontSize="small" />}
          label={t('common:Subscribers_only')}
          sx={{ marginBottom: 1.2, width: 'fit-content' }}
        />

        <Stack gap=".4rem" sx={{ marginBottom: 1.6 }}>
          <Typography variant="text-sm" fontWeight="600" color={GRAY_900}>
            {t('non_subscribers_title')}
          </Typography>
          <Typography variant="text-xs" fontWeight="400" color={GRAY_700} marginTop={0.6}>
            {t('non_subscribers_description')}
          </Typography>
        </Stack>

        <MUIButton
          sx={{ marginTop: 1, fontSize: '12px', width: 'fit-content' }}
          size="sm"
          onClick={handleSubscribeClick}
        >
          {t('subscribe_to_bkbn_button')}
        </MUIButton>

      </Stack>
    </Box>
  )
}
